import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { SelectItem } from 'primeng/primeng';

@Component({
  selector: 'lfwms-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit, OnChanges {

  public dropdownOptions: SelectItem[];
  public selectedOption: any;

  @Input() public inputValue: any;
  @Input() public inputOptions: Array<any> = [];
  @Input() public isDropup: boolean = false;
  @Input() public scrollHeight: string = '328px';
  @Input() public setFirstValuesAsDefault: boolean = true;
  @Input() public isEditable: boolean = false;
  @Output() public valueChanged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('primeFocusInput') primeFocusInput: any;

  /* START: Variables for autoselect/search using keypress inside dropdown */
  searchValue: string;
  searchIndex: number;
  searchTimeout: any;
  previousSearchChar: string;
  currentSearchChar: string;
  /* END: Variables for autoselect/search using keypress inside dropdown */

  //[LFWM-3268] - Adding flag to check initialization.
  private isInitialized: boolean = false;

  public ngOnInit() {
    this.dropdownOptions = [];
    if(this.inputValue.cName === 'isColor' || this.inputValue.cName === 'isDuplex' || this.inputValue.cName === 'isCollate' || this.inputValue.cName === 'isLandscape' || this.inputValue.cName === 'printNextOnFail' ){
      this.selectedOption = this.inputOptions[1].value;
      this.inputOptions.forEach((option: any, index: number) => {
        if (!this.inputOptions[index]['value']) {
          this.dropdownOptions.push({ label: this.inputOptions[index]['key'], value: this.inputOptions[index] });
        } else {
          this.dropdownOptions.push({ label: this.inputOptions[index]['value'], value: this.inputOptions[index] });
        }
      });
      if (this.inputValue.cVal) {        
        const filteredOption: Array<any> = this.inputOptions
          .filter((option: any) => {
            if (option.key) {
              return option.key.toString().trim().toUpperCase() === this.inputValue.cVal.toString().trim().toUpperCase();
            }
          });
        if (filteredOption.length > 0) {
          this.selectedOption = filteredOption[0];
        }else if(!this.isEditable){         
          this.dropdownOptions.unshift({label: this.inputValue.cVal, value: this.inputValue.cVal});
          this.selectedOption = this.dropdownOptions[0].value;
        }
      } else {
        if (this.inputValue.cValOrig!="" && this.setFirstValuesAsDefault) {
          // If cVal is undefined, the dropdown should default to first available option
          this.selectedOption = this.inputOptions[1]; // Updating Dropdown component model
          this.inputValue.cVal = this.inputOptions[1]['key']; // Update cVal
        } else {
          this.selectedOption = [];
          this.inputValue.cVal = '';
        }
      }

    }
    else if (this.inputOptions.length === 0) {
      /* [LFWM-2114] - isEditable - true - Editable Dropdown
        * inputOptions is zero when the dropdown field has no values in metadata ,
        * if inputvalue of dropdown is not null and editable dropdown - input value is pushed into dropdownOptions and
          assigned to default value of dropdown on page load - input value is displayed instead of No Options */
      if (this.inputValue.cVal && this.inputValue.cVal.trim()) {
        this.dropdownOptions.push({label: this.inputValue.cVal, value: this.inputValue.cVal});
        this.selectedOption = this.dropdownOptions[0].value;
        // LFWM-4371 For dropdowns to show as blank instead of ‘No Options’.
      } else {
        this.dropdownOptions.push({ label: '', value: null });
      }
    } else {
      this.inputOptions.forEach((option: any, index: number) => {
        if (!this.inputOptions[index]['value']) {
          this.dropdownOptions.push({ label: this.inputOptions[index]['key'], value: this.inputOptions[index] });
        } else {
          this.dropdownOptions.push({ label: this.inputOptions[index]['value'], value: this.inputOptions[index] });
        }
      });
      if (this.inputValue.cVal) {
        //LFWM-3020 - Making key comparison case insensitive.
        const filteredOption: Array<any> = this.inputOptions
          .filter((option: any) => {
            if (option.key) {
              return option.key.toString().trim().toUpperCase() === this.inputValue.cVal.toString().trim().toUpperCase();
            }
          });
        if (filteredOption.length > 0) {
          this.selectedOption = filteredOption[0];
        }else if(!this.isEditable){
          //[LFWM-3268] - Adding dropdown option if value not present.
          this.dropdownOptions.unshift({label: this.inputValue.cVal, value: this.inputValue.cVal});
          this.selectedOption = this.dropdownOptions[0].value;
        }
      } else {
        if (this.setFirstValuesAsDefault) {
          // If cVal is undefined, the dropdown should default to first available option
          this.selectedOption = this.inputOptions[0]; // Updating Dropdown component model
          this.inputValue.cVal = this.inputOptions[0]['key']; // Update cVal
        } else {
          this.selectedOption = [];
          this.inputValue.cVal = '';
        }
      }
    }
    this.isInitialized = true;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['inputValue'] || changes['inputOptions']) {
      this.dropdownOptions = [];
      if(this.inputOptions !== undefined){
        if (this.inputOptions.length === 0) {
          //  LFWM-4371 For dropdows to show as blank instead of ‘No Options’.
          this.dropdownOptions.push({ label: '', value: null });
        } else {
        this.inputOptions.forEach((option: any, index: number) => {
          if (!this.inputOptions[index]['value']) {
            this.dropdownOptions.push({ label: this.inputOptions[index]['key'], value: this.inputOptions[index] });
          } else {
            this.dropdownOptions.push({ label: this.inputOptions[index]['value'], value: this.inputOptions[index] });
          }
        });
        if (this.inputValue.cVal) {
          const filteredOption: Array<any> = this.inputOptions
            .filter((option: any) => {
              if (option.key) {
                return option.key.toString().trim().toUpperCase() === this.inputValue.cVal.toString().trim().toUpperCase();
              }
            });
          if (filteredOption.length > 0) {
            this.selectedOption = filteredOption[0];
          } else {
            /* [LFWM-2114] - isEditable - true - Editable Dropdown
            * if filtered option length is zero - the input value is not listed in the input options of the dropdown,
            * then the input value is assigned to default option of dropdown */
            if (this.isEditable) {
              this.selectedOption = this.inputValue.cVal;
            } else if(this.isInitialized){
              ////[LFWM-3268] - Don't allow reset to first value before initialization.
              // this.inputOptions.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
              this.selectedOption = this.inputOptions[0];
              this.inputValue.cVal = this.inputOptions[0]['key'];
            }
          }
        } else {
          if (this.setFirstValuesAsDefault) {
            // If cVal is undefined, the dropdown should default to first available option
            this.selectedOption = this.inputOptions[0]; // Updating Dropdown component model
            this.inputValue.cVal = this.inputOptions[0]['key']; // Update cVal
          } else {
            this.selectedOption = [];
          //  this.inputValue.cVal = '';
          }

        }
      }
    }
    }
  }
  public setFocus() {
    this.primeFocusInput.focusViewChild.nativeElement.focus();
  }

  public onSelect($event: any) {
    const prevVal = this.inputValue.cVal;
    if ($event.value['key']) {
      this.inputValue.cVal = $event.value['key'];
    } else if (typeof $event.value === 'string') {
      this.inputValue.cVal = $event.value;
    } else {
      this.inputValue.cVal = '';
    }
    // this.inputValue.cVal = $event.value['key'] ? $event.value['key'] : $event.value;
    this.valueChanged.emit({ type: 'dropdown', prevVal: prevVal, newVal: this.inputValue.cVal });
  }

  public onFocus() {
    const intervalID = setInterval(() => {
      if (this.primeFocusInput.panelVisible) {
        const subIntervalID = setInterval(() => {
          if (this.primeFocusInput.panelViewChild.nativeElement.style.top || this.primeFocusInput.panelViewChild.nativeElement.style.bottom) {
            if (this.isDropup) {
              this.primeFocusInput.panelViewChild.nativeElement.style.bottom = '100%';
              this.primeFocusInput.panelViewChild.nativeElement.style.top = 'unset';
            } else {
              this.primeFocusInput.panelViewChild.nativeElement.style.bottom = 'unset';
              this.primeFocusInput.panelViewChild.nativeElement.style.top = '100%';
            }
            clearInterval(subIntervalID);
          }
        }, 1);
        clearInterval(intervalID);
      }
    }, 1);
  }


  /* START: Code for autoselect/search using keypress inside dropdown */
/*    The keypress select functionality is not available in prime-ng v4.
      Below snippets have been taken from prime-ng v7 implementation and has
      been modified/optimised to work with WMS custom wrapper implementation for prime-ng v4 dropdown,
      so that the functionality is added to prime-ng v4 without breaking the actual v4 implementation.*/
  onKeydown(event: KeyboardEvent) {
    // if (this.readonly || !this.optionsToDisplay || this.optionsToDisplay.length === null) {
    //     return;
    // }
    switch (event.which) {
      // down
      case 40:
      // up
      case 38:
      // space
      case 32:
      // enter
      case 13:
      // escape and tab
      case 27:
      case 9:
        // do nothing.Let prime-ng handle the special cases
        break;

      // search item based on keyboard input
      default:
        /* [LFWM-2114] - isEditable - true- EDITABLE DROPDOWN - when user keyin the value, disabling autoselect/search.
        Either we can enable editable dropdown or autoselect. */
        if (!this.isEditable) {
          this.search(event);
        }
        break;
    }
  }

  search(event) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    const char = String.fromCharCode(event.keyCode);
    this.previousSearchChar = this.currentSearchChar;
    this.currentSearchChar = char;

    /* if (this.previousSearchChar === this.currentSearchChar) {
      this.searchValue = this.currentSearchChar;
    } else {
      this.searchValue = this.searchValue ? this.searchValue + char : char;
    } */
    this.searchValue = this.searchValue ? this.searchValue + char : char;
    let newOption;
    let searchIndex = this.selectedOption ? this.findOptionIndex(this.selectedOption.value, this.dropdownOptions) : -1;
    newOption = this.searchOption(++searchIndex);

  if (newOption) {
    // Only update if the value has changed and the user has stopped typing for a short time
    if (this.previousSearchChar !== this.currentSearchChar) {
      const prevVal = this.inputValue.cVal;

      // Only update the selection if the value has changed
      if (prevVal !== newOption.value.key) {
        this.selectedOption = newOption.value;
        this.inputValue.cVal = newOption.value.key;

        // Emit the change event
        this.valueChanged.emit({
          type: 'dropdown',
          prevVal: prevVal,
          newVal: this.inputValue.cVal,
        });
      }
    }
  }

    this.searchTimeout = setTimeout(() => {
      this.searchValue = null;
    }, 500);
  }

  searchOption(index) {
    let option;

    if (this.searchValue) {
      option = this.searchOptionInRange(index, this.dropdownOptions.length);

      if (!option) {
        option = this.searchOptionInRange(0, index);
      }
    }

    return option;
  }

  searchOptionInRange(start, end) {
    for (let i = start; i < end; i++) {
      const opt = this.dropdownOptions[i];
      if (opt.label.toLowerCase().startsWith(this.searchValue.toLowerCase())) {
        return opt;
      }
    }

    return null;
  }

  findOptionIndex(val: any, opts: any[]): number {
    let index: number = -1;
    if (opts) {
      for (let i = 0; i < opts.length; i++) {
        // if ((val == null && opts[i].value == null) || this.objectUtils.equals(val, opts[i].value, this.dataKey)) {
        if ((val == null && opts[i].value == null) || val === opts[i].value.value) {
          index = i;
          break;
        }
      }
    }

    return index;
  }
  /* END: Code for autoselect/search using keypress inside dropdown */
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/dropdown/dropdown.component.ts